import React from "react";
import ReactDOM from "react-dom";
import styles from "./ModuleAlert.module.scss";

interface AlertProps {
  message: string;
  type: "success" | "error";
  onClose: () => void;
  duration?: number;
}

export const ModuleAlert: React.FC<AlertProps> = ({ message, type, onClose, duration = 5000 }) => {
  React.useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [onClose, duration]);

  return ReactDOM.createPortal(
    <div className={`${styles.alert} ${styles[type]}`}>
      <span>{message}</span>
      <button className={styles.closeButton} onClick={onClose}>
        &times;
      </button>
    </div>,
    document.body
  );
};